export default __webpack_public_path__ + "static/media/Government_Of_Sharjah.91114628.svg";